import React from 'react'
import type { WSStatus } from '../../api/wsClient'
import styles from './WSStatusIndicator.module.css'

export interface WSStatusIndicatorProps {
  status: WSStatus
  className?: string
}

interface StatusConfig {
  label: string
  className: string
  hasSpinner?: boolean
}

const STATUS_CONFIGS: Record<WSStatus, StatusConfig> = {
  connecting: {
    label: 'CONNECTING',
    className: styles.connecting,
    hasSpinner: true,
  },
  connected: {
    label: 'CONNECTED',
    className: styles.connected,
  },
  disconnecting: {
    label: 'DISCONNECTING',
    className: styles.disconnecting,
    hasSpinner: true,
  },
  disconnected: {
    label: 'DISCONNECTED',
    className: styles.disconnected,
  },
  error: {
    label: 'WS ERROR',
    className: styles.error,
  },
}

export function WSStatusIndicator({ status, className }: WSStatusIndicatorProps) {
  const config = STATUS_CONFIGS[status] || STATUS_CONFIGS.disconnected

  return (
    <div
      className={`${styles.container} ${config.className} ${className || ''}`}
      role="status"
      aria-label={`WebSocket status: ${config.label}`}
      data-status={status}
      data-testid="ws-status-indicator"
    >
      {config.hasSpinner ? (
        <span className={styles.spinner} aria-hidden="true" />
      ) : (
        <span className={styles.dot} aria-hidden="true" />
      )}
      <span>{config.label}</span>
    </div>
  )
}
